import React, {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Button, Container, Input, Text} from '../components/@FreeModel';
import Header from '../components/general/Header/Header';
import {gql, verificationCodeConfirm, verificationCodeResend} from "../db/model";
import {useDispatch} from "react-redux";
import {Snackbar} from "@mui/material";

const ContactInfoSMS = (): React.ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const {applicationID} = useParams()

  const [confirmationCode, setConfirmationCode] = useState('');

  const [open, setOpen] = useState(false)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // @ts-ignore
    dispatch(gql({
      query: verificationCodeConfirm,
      variables: {id: applicationID, code: confirmationCode},
      onSuccess: (_) => navigate(`/contractors/${applicationID}/business-info/1`)
    }))
  };

  const handleResend = async () => {
    // @ts-ignore
    dispatch(gql({
      query: verificationCodeResend,
      variables: {id: applicationID},
      onSuccess: (content) => setOpen(true)
    }))
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Container>
      <Header
        title="Confirm your mobile phone number"
        text="You should have received a text message with a six-digit number. Enter it below to confirm your phone number."
      />

      <form onSubmit={handleSubmit}>
        <Input
          label="Enter confirmation code"
          id="confirmation-code"
          type="text"
          required
          value={confirmationCode}
          onChange={e => setConfirmationCode(e.target.value)}
        />

        <br/>
        <br/>

        <Button>Continue</Button>

        <br/>

        <Text color="gray" lineHeight="sm" size="sm" style={{textAlign: 'center'}}>
          Didn't receive a text?{' '}
          <Text
            onClick={handleResend}
            weight="bold"
            color="blue"
            lineHeight="sm"
            size="sm"
            style={{cursor: 'pointer'}}
            inline
          >
            Resend
          </Text>
        </Text>
      </form>
      <Snackbar
        anchorOrigin={{horizontal: 'center', vertical: 'bottom'}}
        open={open}
        autoHideDuration={4000}
        onClose={handleClose}
        message="Verification code resent"
      />
    </Container>
  );
};

export default ContactInfoSMS;
